/**
 * Initialize Bootstrap tooltips for the supplier dashboard and activities page.
 * 
 * This module initializes tooltips for action buttons (Edit, Delete)
 * in the supplier dashboard table and activities list.
 */

export function initDashboardTooltips() {
  // Initialize tooltips for both dashboard and activities page
  const tooltips = document.querySelectorAll('.supplier-content [data-bs-toggle="tooltip"], .supplier-dashboard [data-bs-toggle="tooltip"]');
  
  if (tooltips.length > 0) {
    // Bootstrap is loaded from CDN before bundle.js, so it should be available
    if (window.bootstrap && window.bootstrap.Tooltip) {
      tooltips.forEach(tooltipTriggerEl => {
        new window.bootstrap.Tooltip(tooltipTriggerEl);
      });
    } else {
      console.warn('Bootstrap Tooltip not available. Make sure Bootstrap JS is loaded.');
    }
  }
}

